import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { addDivisionList, fetchDivisionList } from "../../../slices/LocationSlice/divisionSlice";
import { setStateId } from "../../../slices/LocationSlice/stateSlice";
import { fetchPincodeList } from "../../../slices/LocationSlice/pincodeSlice";
import Loader from "../../../components/Loader";
import SearchableSelect from "../../../components/SearchableSelect";
import {addDistrictList, fetchDistrictList} from "../../../slices/LocationSlice/districtSlice"

const AddDistrict = ({optionList, countryList, stateList, pincodeList}) => {
  const dispatch = useDispatch();
  const stateId = useSelector((state) => state.state.stateId);
  
  const [formData, setFormData] = useState({
    title: "",
    code: "",
    val: "",
    optionType: "",
    // country:"",
    // state:"",
    // pincode:"",
  });

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "val" || name === "optionType" ? Number(value) : value,
    }));

    if(name==="state"){
     await dispatch(setStateId(value));
     await dispatch(fetchPincodeList(value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      title: formData.title,
      translate: { English: formData.title },
      code: formData.code,
      val: formData.val,
      optionType: formData.optionType,
      // country:formData.country,
      // state:formData.state,
      // pincode:formData.pincode,
    };

    const resp = await dispatch(addDistrictList(data));

    // Reset form
    if(!resp.error){
        setFormData({
            title: "",
            code: "",
            val: "",
            optionType: "",
            // country:"",
            // state:"",
            // pincode:""
          });

    dispatch(fetchDistrictList(stateId));
    }
   
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-md mx-auto">
    
      <input
        type="text"
        name="title"
        placeholder="Title"
        value={formData.title}
        onChange={handleChange}
        className="w-full p-1 border rounded border-gray-400"
        required
      />
      
      <input
        type="text"
        name="code"
        placeholder="Code"
        value={formData.code}
        onChange={handleChange}
        className="w-full p-1 border rounded border-gray-400"
        required
      />
      <input
        type="number"
        name="val"
        placeholder="Value"
        value={formData.val}
        onChange={handleChange}
        className="w-full p-1 border border-gray-400 rounded bg-white"
        required
      />
      {/* <select className="w-full p-1 border rounded" name="optionType" value={formData.optionType}  onChange={handleChange}>
       <option value="" disabled >
                        Select option type
                      </option>
                      {optionList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

      {/* <select className="w-full p-1 border rounded" name="state" value={formData.state}  onChange={handleChange}>
       <option value="" disabled >
                        Select State
                      </option>
                      {stateList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

{/* 
      <select className="w-full p-1 border rounded" name="pincode" value={formData.pincode}  onChange={handleChange}>
       <option value="" disabled >
                        Select Pincode
                      </option>
                      {pincodeList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

      <SearchableSelect list={optionList} formData={formData} handleChange={handleChange} name="optionType" placeholder="Select Option Type" />

      {/* <SearchableSelect list={stateList} formData={formData} handleChange={handleChange} name="state" placeholder="Select State" />

      <SearchableSelect list={pincodeList} formData={formData} handleChange={handleChange} name="pincode" placeholder="Select Pincode" />

      <SearchableSelect list={countryList} formData={formData} handleChange={handleChange} name="country" placeholder="Select Country" /> */}

{/* 
      <select className="w-full p-1 border rounded" name="country" value={formData.country}  onChange={handleChange}>
       <option value="" disabled >
                        Select Country
                      </option>
                      {countryList?.result?.map((option, i) => (
                        <option key={i} value={option.id}>
                          {option.title}
                        </option>
                      ))}
      </select> */}

     
      <button
        type="submit"
        className="w-full bg-[var(--mainCol)] text-white p-2 rounded"
      >
        Add District
      </button>
    </form>
  );
};

export default AddDistrict;
